import React, { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Home', target: 'hero' },
  { label: 'About', target: 'about' },
  { label: 'Projects', target: 'projects' },
  { label: 'Contact', target: 'contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('hero');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);

      const sections = navLinks.map(l => l.target);
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && el.getBoundingClientRect().top <= 200) {
          setActive(sections[i]);
          break;
        }
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <img
        src={process.env.PUBLIC_URL + '/vk-logo.png'}
        alt="VK"
        className="nav-logo-img"
        onClick={() => scrollTo('hero')}
      />
      {navLinks.map(link => (
        <button
          key={link.target}
          className={`nav-link ${active === link.target ? 'active' : ''}`}
          onClick={() => scrollTo(link.target)}
        >
          {link.label}
        </button>
      ))}
    </nav>
  );
};

export default Navbar;
